import React from 'react';
import styled from 'styled-components';
import Play from '../assets/play-big.svg';
import Stop from '../assets/stop.svg';
import media from '../style/media';
import Spinner from './Spinner';

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 48px;
  width: 48px;
  ${media.tablet`
    height: 64px;
    width: 64px;
  `}
`;

const Button = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color:rgb(33, 150, 243);
  border-radius: 50%;
  cursor: pointer;
  height: inherit;
  width: inherit;
`;

const Icon = styled.img`
  width: 100%;
  padding: 24px;
  ${media.tablet`
    padding: 16px;
  `}
`;

export interface IStartButton {
  /**
   *  Displays a spinner when isLoading is true
   */
  isLoading;
  /**
   *  function triggered on button click
   */
  onClick: () => void;
  /**
   *  Displays whether the current session state is measuring
   */
  isMeasuring: boolean;
}

const StartButton = ({ isLoading, onClick, isMeasuring }: IStartButton) => {
  return (
    <Container>
      {isLoading ? (
        <Spinner />
      ) : !isMeasuring &&(
        <Button onClick={onClick}>
          <Icon src={isMeasuring ? Stop : Play} />
        </Button>
      )}
    </Container>
  );
};

export default StartButton;
